export const SET_FUTURE_RELESES_PERIOD = "SET_FUTURE_RELESES_PERIOD";